import { render } from "./selectFactura.vue?vue&type=template&id=2b184390"
import script from "./selectFactura.vue?vue&type=script&lang=ts"
export * from "./selectFactura.vue?vue&type=script&lang=ts"
script.render = render

export default script